export enum FormFields {
  BuildingTypes = "buildingTypes",
  Units = "units",
  NumberOfUnit = "numberOfUnit",
  MinPrice = "minPrice",
  MaxPrice = "maxPrice",
  AmenityIds = "amenityIds",
  ScheduleConstructionStartDate = "scheduleConstructionStartDate",
  ScheduleConstructionEndDate = "scheduleConstructionEndDate",
  ProjectStatuses = "projectStatuses",
  YearBuildMin = "yearBuildMin",
  YearBuildMax = "yearBuildMax",
  CreatedAt = "createdAt",
  CompletionDate = "completionDate",
  TransactionType = "transactionType",
  Markets = "markets",
}

export const FormFieldsList = [
  FormFields.BuildingTypes,
  FormFields.Units,
  FormFields.NumberOfUnit,
  FormFields.MinPrice,
  FormFields.MaxPrice,
  FormFields.AmenityIds,
  FormFields.ScheduleConstructionStartDate,
  FormFields.ScheduleConstructionEndDate,
  FormFields.ProjectStatuses,
  FormFields.YearBuildMin,
  FormFields.YearBuildMax,
  FormFields.CreatedAt,
  FormFields.CompletionDate,
  FormFields.TransactionType,
  FormFields.Markets,
];
